<template>
    <div style="width: 100%; height: 100%; position: relative;">
        <model-viewer
            ar
            ref="modelViewer"
            v-if="url"
            :src="url" 
            camera-controls
            :camera-orbit="`${theta}deg ${phi}deg ${radius}m`"
            name="hoang"
            brightness="1"
            shadow-intensity="0.5"
            slot="canvas"
        ></model-viewer>
        <div v-if="loading" class="model-viewer-container__loading">
            <div class="spinnerQr"></div>
        </div>
        <!-- auto-rotate  -->
        <!-- <div class="controls-3d">
            <button type="button" class="controls-3d-button" @click="zoomIn">
                <v-icon
                    style="width: 23px"
                    name="zoom-in"
                ></v-icon>
            </button>
            <button type="button" class="controls-3d-button" @click="zoomOut">
                <v-icon
                    style="width: 23px"
                    name="zoom-out"
                ></v-icon>
            </button>
        </div> -->
    </div>
</template>

<script>

    export default {
        name: "ModelViewerAr",
        data(){
            return {
                loading: false,
                theta: 0,
                phi: 90,
                radius: 2.5,
                isScoll: false,
                zoomFactor: 1.2
            }
        },
        props: {
            url: {
                type: String,
                default(){
                    return null;
                }
            }
        },
        mounted(){
            this.initializeCameraOrbit();
        },
        created(){
            
        },
        methods: {
            initializeCameraOrbit() {
                const modelViewer = this.$refs.modelViewer;
                // modelViewer.addEventListener('camera-change', () => {
                //     const { theta, phi, radius } = modelViewer.getCameraOrbit();
                //     this.theta = this.radianToDegree(theta);
                //     this.phi = this.radianToDegree(phi);
                //     this.radius = this.isScoll ? radius : 2.5;
                // });
                // modelViewer.addEventListener('wheel', () => {
                //     this.isScoll = true;
                // });
                modelViewer.addEventListener('progress', (event) => {
                    const progress = event.detail;
                    if(progress.totalProgress == 0){
                        this.radius = 2.5;
                        this.loading = true;
                    }
                    if(
                        progress && 
                        progress.reason == 'model-load' && 
                        progress.totalProgress == 1
                    ){
                        this.loading = false;
                    }
                });
            },
            radianToDegree(radian) {
                const degree = radian * (180 / Math.PI);
                return degree;
            },
            zoomIn(){
                const {theta, phi, radius} = this;
                const {zoomFactor} = this;
                const parts = (`${theta}deg ${phi}deg ${radius}m`).split(' ');
                const radiusNew = parseFloat(parts[2]) / zoomFactor;
                this.radius = radiusNew;
                this.isScoll = true;
            },
            zoomOut(){
                const {theta, phi, radius} = this;
                const {zoomFactor} = this;
                const parts = (`${theta}deg ${phi}deg ${radius}m`).split(' ');
                const radiusNew = parseFloat(parts[2]) * zoomFactor;
                this.radius = radiusNew;
                this.isScoll = true;
            }
        }
    }
</script>

<style>
    .controls-3d{
        position: absolute;
        right: 0;
        top: 0;
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }
    .controls-3d-button {
        height: 35px;
        width: 35px;
        min-width: 35px;
        max-width: 35px;
        min-height: 35px;
        max-height: 35px;
        font-size: 18px;
        font-family: system-ui;
        font-weight: 600;
        color: #333333d4;
        -webkit-box-shadow: 0px 2px 4px -1px #333;
        box-shadow: 0px 2px 4px -1px #333;
        outline: none;
        border: none;
        border-radius: 50%;
        margin-bottom: 10px;
        background: #fff;
        transition: 0.6s;
    }
    .spinnerQr {
        margin: 0px auto;
        width: 30px;
        height: 30px;
        border: 4px solid rgba(0, 0, 0, 0.1);
        border-top: 4px solid #999;
        border-radius: 50%;
        animation: spinQr 1s linear infinite;
        transition: 0.6s;
    }
    @keyframes spinQr {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>


// WEBPACK FOOTER //
// src/components/Utilities/ModelViewerAr.vue